 export interface DataType {
  id: string;
  name: string; 
  createTime: string;
  updateTime: string;
  remark: string;
  supplyChannelAppId: number;
  supplyChannelAppName: string;
}

export const column = [
  {
    title: '渠道编号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '渠道名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '供货渠道应用名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
  }
];